export const containers = [
    {
        date: '05/01/2023',
        hour: '13:00/19:00',
        eta: '02/01/2023',
        place: 'AL 1/2',
        ship: 'CELSO FURTADO',
        cargo: 'OLEO DIESEL',
        event: 'ATRACACAO',
        voyage: '5088/2022',
        duv: '534012022',
    },
    {
        date: '05/01/2023',
        hour: '13:00/19:00',
        eta: '02/01/2023',
        place: 'AL 3/IBSP/BC',
        ship: 'STOLT COBALT',
        cargo: 'GRAN.LIQUIDO NAO ESPECIF',
        event: 'MUDANCA',
        voyage: '5420/2022',
        duv: '560152022',
    },
    {
        date: '05/01/2023',
        hour: '13:00/19:00',
        eta: '23/12/2022',
        place: 'BARRA/TIPLAN 3',
        ship: 'WINDSOR ADVENTURE',
        cargo: 'ACUCAR A GRANEL',
        event: 'REATRACACAO',
        voyage: '5349/2022',
        duv: '556382022',
    },
    {
        date: '05/01/2023',
        hour: '13:00/19:00',
        eta: '02/01/2023',
        place: 'AL 1/2',
        ship: 'CELSO FURTADO',
        cargo: 'OLEO DIESEL',
        event: 'ATRACACAO',
        voyage: '5088/2022',
        duv: '534012022',
    },
    {
        date: '05/01/2023',
        hour: '13:00/19:00',
        eta: '02/01/2023',
        place: 'AL 3/IBSP/BC',
        ship: 'STOLT COBALT',
        cargo: 'GRAN.LIQUIDO NAO ESPECIF',
        event: 'MUDANCA',
        voyage: '5420/2022',
        duv: '560152022',
    },
    {
        date: '05/01/2023',
        hour: '13:00/19:00',
        eta: '23/12/2022',
        place: 'BARRA/TIPLAN 3',
        ship: 'WINDSOR ADVENTURE',
        cargo: 'ACUCAR A GRANEL',
        event: 'REATRACACAO',
        voyage: '5349/2022',
        duv: '556382022',
    },
    {
        date: '05/01/2023',
        hour: '13:00/19:00',
        eta: '02/01/2023',
        place: 'AL 1/2',
        ship: 'CELSO FURTADO',
        cargo: 'OLEO DIESEL',
        event: 'ATRACACAO',
        voyage: '5088/2022',
        duv: '534012022',
    },
    {
        date: '05/01/2023',
        hour: '13:00/19:00',
        eta: '02/01/2023',
        place: 'AL 3/IBSP/BC',
        ship: 'STOLT COBALT',
        cargo: 'GRAN.LIQUIDO NAO ESPECIF',
        event: 'MUDANCA',
        voyage: '5420/2022',
        duv: '560152022',
    },
    {
        date: '05/01/2023',
        hour: '13:00/19:00',
        eta: '23/12/2022',
        place: 'BARRA/TIPLAN 3',
        ship: 'WINDSOR ADVENTURE',
        cargo: 'ACUCAR A GRANEL',
        event: 'REATRACACAO',
        voyage: '5349/2022',
        duv: '556382022',
    },
    {
        date: '05/01/2023',
        hour: '13:00/19:00',
        eta: '02/01/2023',
        place: 'AL 1/2',
        ship: 'CELSO FURTADO',
        cargo: 'OLEO DIESEL',
        event: 'ATRACACAO',
        voyage: '5088/2022',
        duv: '534012022',
    },
    {
        date: '05/01/2023',
        hour: '13:00/19:00',
        eta: '02/01/2023',
        place: 'AL 3/IBSP/BC',
        ship: 'STOLT COBALT',
        cargo: 'GRAN.LIQUIDO NAO ESPECIF',
        event: 'MUDANCA',
        voyage: '5420/2022',
        duv: '560152022',
    },
    {
        date: '05/01/2023',
        hour: '13:00/19:00',
        eta: '23/12/2022',
        place: 'BARRA/TIPLAN 3',
        ship: 'WINDSOR ADVENTURE',
        cargo: 'ACUCAR A GRANEL',
        event: 'REATRACACAO',
        voyage: '5349/2022',
        duv: '556382022',
    },
    {
        date: '05/01/2023',
        hour: '13:00/19:00',
        eta: '02/01/2023',
        place: 'AL 1/2',
        ship: 'CELSO FURTADO',
        cargo: 'OLEO DIESEL',
        event: 'ATRACACAO',
        voyage: '5088/2022',
        duv: '534012022',
    },
    {
        date: '05/01/2023',
        hour: '13:00/19:00',
        eta: '02/01/2023',
        place: 'AL 3/IBSP/BC',
        ship: 'STOLT COBALT',
        cargo: 'GRAN.LIQUIDO NAO ESPECIF',
        event: 'MUDANCA',
        voyage: '5420/2022',
        duv: '560152022',
    },
    {
        date: '05/01/2023',
        hour: '13:00/19:00',
        eta: '23/12/2022',
        place: 'BARRA/TIPLAN 3',
        ship: 'WINDSOR ADVENTURE',
        cargo: 'ACUCAR A GRANEL',
        event: 'REATRACACAO',
        voyage: '5349/2022',
        duv: '556382022',
    },
]